import { render, staticRenderFns } from "./StandingAccountDetail.vue?vue&type=template&id=545b3bbe&scoped=true"
import script from "./StandingAccountDetail.vue?vue&type=script&lang=js"
export * from "./StandingAccountDetail.vue?vue&type=script&lang=js"
import style0 from "./StandingAccountDetail.vue?vue&type=style&index=0&id=545b3bbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545b3bbe",
  null
  
)

export default component.exports